module.exports = __webpack_public_path__ + "static/media/about23.900d6bac.webp";